import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full py-6 border-t border-outline-variant/10 bg-surface">
      <div className="px-8 md:px-12">
        <p className="font-label text-[10px] uppercase tracking-[0.2em] text-on-surface-variant/50">
          &copy; 2024 The Curated Wilderness. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
